import { Outlet } from "react-router-dom";
import styled, { css } from "styled-components";

import { WrapperProps } from "@sso/ui/FlexBox";

const StyledMainContent = styled.main<WrapperProps>`
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  padding: 1rem;
  margin: 0 1rem;
  border-radius: 1rem 1rem 0 0;
  width: 100vw;
  min-width: 0;
  transition: all 0.3s;
  background-color: ${p => p.theme.colors.primary.light};
  margin-top: ${p => p.theme.headerHeight};
  min-height: calc(100vh - ${p => p.theme.headerHeight});
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    margin-right: 0;
    margin-left: 0;
  }
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    ${p =>
      p.open &&
      css`
        margin-left: calc(${p.theme.drawerWidth} + 1rem);
        width: calc(100% - ${p.theme.drawerWidth});
      `}
  }
`;

interface MainContentProps {
  drawerOpen: boolean;
}
export const MainContent = ({ drawerOpen }: MainContentProps) => {
  return (
    <StyledMainContent open={drawerOpen}>
      <Outlet />
    </StyledMainContent>
  );
};
